export class FormData {
  name: string = 'New Lease';
  formHtml = '';
  $key: string;
  units = [];
  helloSignTemplateId?: string;
  helloSignInsuranceTemplateId?: string;
  isDefault = false;
  hasSeparateInsuranceLease = false;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/formData.ts